import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import marcosImg from "@/assets/testimonial-marcos.webp";
import fernandaImg from "@/assets/testimonial-fernanda.webp";
import robertoImg from "@/assets/testimonial-roberto.webp";

const testimonials = [
  {
    name: "Marcos Oliveira",
    role: "CEO — Distribuidora Nordeste Plus · Maceió, AL",
    text: "Em 6 meses com o Negócio Conectado, aumentamos nosso faturamento em 40%. A metodologia é prática e direta ao ponto.",
    photo: marcosImg,
  },
  {
    name: "Fernanda Costa",
    role: "Diretora — Clínica VidaSaúde · São Paulo, SP",
    text: "A telemedicina empresarial mudou a qualidade de vida dos nossos colaboradores. Reduzimos afastamentos em 30%.",
    photo: fernandaImg,
  },
  {
    name: "Roberto Lima",
    role: "Fundador — TechServ Soluções · Recife, PE",
    text: "A máquina de vendas B2B transformou nosso comercial. Passamos de 2 para 12 reuniões qualificadas por semana.",
    photo: robertoImg,
  },
];

const SocialProofSection = () => (
  <section className="py-16 md:py-24">
    <div className="container">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mb-12 text-center"
      >
        <span className="mb-3 inline-block rounded-full bg-accent px-4 py-1.5 text-sm font-semibold text-accent-foreground">
          Prova Social
        </span>
        <h2 className="text-2xl font-extrabold text-foreground sm:text-3xl md:text-4xl">
          Resultados que falam por si
        </h2>
      </motion.div>

      <div className="grid gap-6 md:grid-cols-3">
        {testimonials.map((t, i) => (
          <motion.div
            key={t.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="relative rounded-xl border border-border bg-card p-6 shadow-card"
          >
            <Quote className="mb-4 h-8 w-8 text-primary/20" />
            <p className="mb-6 text-sm leading-relaxed text-muted-foreground">"{t.text}"</p>
            <div className="flex items-center gap-1 mb-3">
              {[...Array(5)].map((_, j) => (
                <Star key={j} className="h-4 w-4 fill-primary text-primary" />
              ))}
            </div>
            <div className="flex items-center gap-3">
              <img src={t.photo} alt={t.name} width={44} height={44} loading="lazy" decoding="async" className="h-11 w-11 rounded-full object-cover" />
              <div>
                <p className="text-sm font-bold text-foreground">{t.name}</p>
                <p className="text-xs text-muted-foreground">{t.role}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default SocialProofSection;
